export default "__VITE_ASSET__BfzsT9Wx__"